import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/Landing',
  },
  {
    path: '/',
    name: 'Layout',
    redirect: '/Landing',
    component: () => import('@/views/Register/Layout.vue'),

    children: [
      {
        path: 'Landing',
        name: 'Landing',
        component: () => import('@/views/Register/Landing.vue'),
        meta: {
          title: 'Landing - Taiwan International Food Industry Show 2022 | Online Exhibition',
        },
      },

      {
        path: 'Login',
        name: 'Login',
        component: () => import('@/views/Register/Login.vue'),
        meta: {
          title: 'Login - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Signup',
        name: 'Signup',
        component: () => import('@/views/Register/Signup.vue'),
        meta: {
          title: 'Signup - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Registration',
        name: 'Registration',
        component: () => import('@/views/Register/Registration.vue'),
        meta: {
          title: 'Registration - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Home',
        name: 'Home',
        component: () => import('@/views/Home/Home.vue'),
        meta: {
          title: 'Home - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'PressReleases/Page=:NewsPage',
        name: 'PressReleases',
        component: () => import('@/views/Home/PressReleases.vue'),
        meta: {
          title: 'PressReleases - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Products/Page=:ProductPage',
        name: 'Products',
        component: () => import('@/views/Home/Products.vue'),
        meta: {
          title: 'Products - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'ProductDetail/:MyProId',
        name: 'ProductDetail',
        component: () => import('@/views/Home/ProductDetail.vue'),
        meta: {
          title: 'ProductDetail - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Videos/Page=:VideoPage',
        name: 'Videos',
        component: () => import('@/views/Home/Videos.vue'),
        meta: {
          title: 'Videos - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'ExhibitorDetail/:MyExhId',
        name: 'ExhibitorDetail',
        component: () => import('@/views/Home/ExhibitorDetail.vue'),
        meta: {
          title: 'ExhibitorDetail - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Exhibitors/Page=:Page',
        name: 'Exhibitors',
        component: () => import('@/views/Home/Exhibitors.vue'),
        meta: {
          title: 'Exhibitors - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'FavoriteExhibitors/Page=:FavExhPage',
        name: 'FavoriteExhibitors',
        component: () => import('@/views/Home/FavoriteExhibitors.vue'),
        meta: {
          title: 'FavoriteExhibitors - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'FavoriteProducts/Page=:FavProPage',
        name: 'FavoriteProducts',
        component: () => import('@/views/Home/FavoriteProducts.vue'),
        meta: {
          title: 'FavoriteProducts - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Edit',
        name: 'Edit',
        component: () => import('@/views/Home/Edit.vue'),
        meta: {
          title: 'Edit - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'AdvanceSearchExhibitors/Page=:SearchExhPage',
        name: 'AdvanceSearchExhibitors',
        component: () => import('@/views/Home/AdvanceSearchExhibitors.vue'),
        meta: {
          title: 'AdvanceSearchExhibitors - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'AdvanceSearchProducts/Page=:SearchProPage',
        name: 'AdvanceSearchProducts',
        component: () => import('@/views/Home/AdvanceSearchProducts.vue'),
        meta: {
          title: 'AdvanceSearchProducts - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'PressReleaseDetail/:MyNewsId',
        name: 'PressReleaseDetail',
        component: () => import('@/views/Home/PressReleaseDetail.vue'),
        meta: {
          title: 'PressReleaseDetail - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'OfficialNewsDetail/:MyLastedNewsId',
        name: 'OfficialNewsDetail',
        component: () => import('@/views/Home/OfficialNewsDetail.vue'),
        meta: {
          title: 'OfficialNewsDetail - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'BrowsingHistoryExhibitors/Page=:HisExhPage',
        name: 'BrowsingHistoryExhibitors',
        component: () => import('@/views/Home/BrowsingHistoryExhibitors.vue'),
        meta: {
          title: 'BrowsingHistoryExhibitors - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'BrowsingHistoryProducts/Page=:HisProPage',
        name: 'BrowsingHistoryProducts',
        component: () => import('@/views/Home/BrowsingHistoryProducts.vue'),
        meta: {
          title: 'BrowsingHistoryProducts - Taiwan International Food Industry Show 2022 | Online Exhibition',
          requiresAuth: true,
        },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/food/onlineexpo/',
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (to.name !== 'Home') {
      if (savedPosition) {
        setTimeout(() => {
          window.scrollTo(savedPosition.x, savedPosition.y)
        }, 200)
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
})

export default router
